import { useEffect, useState } from 'react';
import { validateRules } from '../../dsv-schema-utils';

/**
 * Debounced rule-validation hook. Recomputes the error map 300ms after the
 * last change to either rules or fields, so typing in a constraint input
 * doesn't thrash validation on every keystroke. The caller usually lifts
 * `errors` up via `onValidationChange` so the parent save flow can block
 * on non-empty errors.
 */
export default function useRuleValidation(rules, fields, onValidationChange) {
	const [errors, setErrors] = useState({});

	useEffect(() => {
		const handle = setTimeout(() => {
			const next = validateRules(rules, fields);
			setErrors(next);
			if (typeof onValidationChange === 'function') onValidationChange(next);
		}, 300);
		return () => clearTimeout(handle);
	}, [rules, fields, onValidationChange]);

	return errors;
}
